module.exports = __webpack_public_path__ + "static/media/slider-home-onepage-slide-01-image-02.d56f69cf.png";